


































import { Component, Prop } from 'vue-property-decorator'

import { SuccessChannelInfo } from '../../../../../../../../../models/CheckChannels/CheckChannels'
import { ButtonView, SocketNames } from '../../../../../../components'
import ChannelsInfoHelper from '../../../../../Helpers/ChannelsInfoHelper'
import { SampleNodeMixin } from '../../../../index'
import { CheckSubscriptionNode } from '../../logic/CheckSubscriptionNode'

@Component({
  components: {
    ButtonView,
  },
  data() {
    return {
      ChannelsInfoHelper,
      SocketNames,
    }
  }
})
export default class CheckSubscriptionSampleNode extends SampleNodeMixin {
  @Prop() node!: CheckSubscriptionNode

  get currentChannelText(): any {
    const data = this.node.data
    const titles: Array<string> = []

    data.targets
      .filter(t => !!t)
      .forEach((t) => {
        const isKnown = this.node.nodeProps.targets().find(({ id }) => id === t)

        if (isKnown) {
          titles.push(isKnown.title)
        } else {
          const find = ChannelsInfoHelper.GetChannel(t!.toString())

          if (find && find instanceof SuccessChannelInfo) {
            titles.push(find.info.title)
          }
        }
      })

    if (titles.length) {
      return this.i18n.t('flow_subscription_check_node_check_signed_text', {
        channel: titles.join(', '),
        time: data.time
      }).toString()
    } else {
      return this.i18n.t('flow_subscription_check_node_not_set_channel_text').toString()
    }

    // return this.i18n.t('flow_screenshot_current_channel_text_stub')
  }
}
